import { GetLinks } from 'domain/usecases/get-links';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetLinks extends BaseHttpService<GetLinks.Model> implements GetLinks {
  async get(params: GetLinks.Params): Promise<GetLinks.Model> {
    return await this.request('get', {}, params);
  }
}
